import PropTypes from 'prop-types';
import React from 'react';
import { UX2, constants } from '@wsb/guac-widget-core';
import { ProductStarRating } from './Yotpo';
import dataAids from '../../../constants/dataAids';
import { OlsConfigStore, RouteHandler, ShopViewConstants, ScrollWidgetActions } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import {
  hasSalePrice,
  calculateSalePercentage,
  formatPrice
} from '../utils/ProductUtils';

class ProductListItem extends React.Component {
  constructor() {
    super(...arguments);
    this.handleViewProductDetailClick = this.handleViewProductDetailClick.bind(this);
  }

  handleViewProductDetailClick(e) {
    e.preventDefault();
    const { product } = this.props;
    const slug = product.slug;
    RouteHandler.navigate(ShopViewConstants.PRODUCT_DETAIL, { slug: slug });
    ScrollWidgetActions.scrollShopWidget();
  }

  salePercentageText(product, translate) {
    if (!hasSalePrice(product)) return null;

    const { sale_price, price } = product;
    const percentage = calculateSalePercentage(price, sale_price);
    if (percentage < 1) return null;

    return translate('products.sale_label');
  }

  determinePrice(price) {
    return (!['object', 'undefined'].includes(typeof price)) ?
      formatPrice({ currency: true, number: +price })
      : price;
  }

  get eyebrowText() {
    const { product } = this.props;
    const { translate } = this.context;

    if (product.limited_edition) {
      return translate('products.limited_edition');
    } else if (product.ship_free) {
      return translate('products.free_shipping');
    }
    return null;
  }

  get productCardData() {
    const { product, isRibbonShown, isRatingShown, renderMode, cardSize } = this.props;
    const { imageCropMethod, galleryImageShape, galleryShowBorder } = this.context;
    const { name, id, product_type, default_asset_url, variant_count, has_price_range } = product;
    const translate = this.context.translate || (() => {});
    const saleRibbon = this.salePercentageText(product, translate);
    const hasVariants = variant_count && variant_count >= 2;

    const price = this.determinePrice(product.price);
    const salePrice = hasSalePrice(product) ? this.determinePrice(product.sale_price) : null;

    let ratings;
    if (isRatingShown) {
      const ratingsContainerStyles = {
        textAlign: 'center'
      };

      ratings = (
        <ProductStarRating
          product={ product }
          containerStyle={ ratingsContainerStyles }
          containerClass={ 'product-list' }
          renderMode={ renderMode }
        />);
    }

    /**
     * #Temporary in BEAR-914
     * After BEAR-1005 is done the following properties should change to
     * imageCropMethod,
     * imageShape: galleryImageShape,
     * hasImageBorder: galleryShowBorder
     */
    return {
      id,
      name,
      productType: product_type,
      price: (price && price.display) || price,
      salePrice: (salePrice && salePrice.display) || salePrice,
      imageUrl: default_asset_url || OlsConfigStore.getState().noProductImage,
      ribbonText: isRibbonShown ? saleRibbon : null,
      eyebrowText: this.eyebrowText,
      footerText: hasVariants ? translate('products.more_options') : null,
      imageCropMethod: imageCropMethod || this.props.imageCropMethod,
      imageShape: galleryImageShape || this.props.imageShape,
      hasImageBorder: galleryShowBorder || this.props.galleryShowBorder,
      priceText: has_price_range ? translate('products.from') : null,
      ratings,
      cardSize
    };
  }

  render() {
    const { product, renderMode } = this.props;
    const { Block, Link } = UX2.Element;

    const getLinkProps = this.context.getLinkProps || (() => {});
    const linkProps = getLinkProps(ShopViewConstants.PRODUCT_DETAIL, { slug: product.slug });
    const { name } = product;

    const isEditMode = renderMode === constants.renderModes.EDIT;

    const productDataAids = {
      name: `${dataAids.PRODUCT_CARD_NAME_RENDERED}_${name}`,
      price: `${dataAids.PRODUCT_PRICE_RENDERED}_${name}`,
      image: `${dataAids.PRODUCT_IMAGE_RENDERED}_${name}`,
      salePrice: `${dataAids.PRODUCT_SALE_PRICE_RENDERED}_${name}`,
      eyebrow: `${dataAids.PRODUCT_EYEBROW_RENDERED}_${name}`,
      footer: `${dataAids.PRODUCT_FOOTER_RENDERED}_${name}`,
      ribbon: `${dataAids.PRODUCT_RIBBON_RENDERED}_${name}`
    };

    return (
      <Block>
        <Link
          data-aid={ `${dataAids.PRODUCT_NAME_RENDERED}_${name}` }
          onClick={ !isEditMode && this.handleViewProductDetailClick }
          href='javascript:;'
          { ...linkProps }
        >
          <UX2.Component.CommerceCardItem
            { ...this.productCardData }
            dataAids={ productDataAids }
          />
        </Link>
      </Block>
    );
  }
}

/**
 * #Temporary in BEAR-914
 * After BEAR-1005 is done the following propTypes should be deleted
 * galleryShowBorder,
 * imageCropMethod,
 * imageShape
*/
ProductListItem.propTypes = {
  product: PropTypes.object.isRequired,
  renderMode: PropTypes.string,
  imageShape: PropTypes.string,
  galleryShowBorder: PropTypes.bool,
  imageCropMethod: PropTypes.string,
  isRibbonShown: PropTypes.bool,
  isRatingShown: PropTypes.bool,
  cardSize: PropTypes.object
};

ProductListItem.defaultProps = {
  isRibbonShown: true,
  isRatingShown: true
};

ProductListItem.contextTypes = {
  getLinkProps: PropTypes.func,
  translate: PropTypes.func,
  imageCropMethod: PropTypes.string,
  galleryShowBorder: PropTypes.bool,
  galleryImageShape: PropTypes.string
};

export default ProductListItem;
